<template>
	<div class="travelList">
		<back-to></back-to>
		<section class="travelList-content">
			<div class="travelList-content_item" v-for="(item,index) in travelerList" :key="index">
				<span>
					<p v-for="(map,sort) in item.templatTag" :key="sort" v-if="map.isMain"
						:class="sort == 0?'travelList-content_item-name':'travelList-content_item-tel'">
						{{map.tagValue}}
					</p>
				</span>
				<span>
					<img @click="delate(item)" class="travelList-content_item-del" src="../../assets/comments3.png"
						alt="">
				</span>
			</div>
		</section>
		<section class="travelerForm-bs">
			<p @click="$router.push({ path: '/traveler',query:{templateId:2,type:0}})">添加</p>
		</section>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	import {
		Dialog
	} from 'vant'
	import {
		mapGetters
	} from 'vuex'
	export default {
		name: 'travelList',
		components: {
			BackTo
		},
		data() {
			return {
				travelerList: []
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {
			this.getList()
		},
		methods: {
			getList(e) {
				this.$_getNew(
					this.$severOrder + '/Order_UserTemplateBase/GetByUserId?Id=' + this.userInfo.userId, {}
				).then(res => {
					this.travelerList = res.result
				})
			},
			delate(e) {
				console.log(e)
				Dialog.confirm({
						title: '温馨提示',
						message: '确定删除吗?',
					})
					.then(() => {
						var data = {
							"Id": e.id,
							"UserId": this.userInfo.userId
						}
						this.$_postNew(
							this.$severOrder + '/Order_UserTemplateBase/Delete', data
						).then(res => {
							this.getList()
						})
					})
					.catch(() => {
						// on cancel
					});
			},
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
		}
	}
</script>

<style scoped>
	.travelList-content {
		width: 100%;
		padding: 30px;
		box-sizing: border-box;
	}

	.travelList-content_item {
		width: 100%;
		background: #FFFFFF;
		border-radius: 20px;
		margin-bottom: 28px;
		display: flex;
		justify-content: space-between;
		padding: 28px 40px 18px 40px;
		box-sizing: border-box;
	}

	.travelList-content_item span {
		display: flex;
		flex-direction: column;
	}

	.travelList-content_item span p {
		padding-bottom: 10px;
	}

	.travelList-content_item-tel {
		color: #999999;
		font-size: 26px;
	}

	.travelList-content_item-name {
		font-weight: bold;
		font-size: 32px;
		color: #333333;
	}

	.travelList-content_item-del {
		width: 36px;
		height: 36px;
	}

	.travelerForm-bs {
		position: fixed;
		bottom: 20px;
		left: 50%;
		transform: translateX(-50%);
	}

	.travelerForm-bs p {
		width: 710px;
		margin: 40px auto;
		height: 90px;
		line-height: 90px;
		text-align: center;
		background: #F9902F;
		box-shadow: 0px 3px 10px 1px rgba(236, 224, 215, 0.6784);
		font-size: 32px;
		color: #fff;
		border-radius: 40px;
	}
</style>